export const VALID_URL_REGEX =
  /(https?:\/\/(www\.)?)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

export const validateLinkTypeAttachmentUrl = (url: string) => {
  return VALID_URL_REGEX.test(url);
};
